import { CommonModule, NgClass } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
  input,
  signal,
} from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { AddToCartBottomUpComponent } from '@components/dialog/add-to-cart-bottom-up/add-to-cart-bottom-up.component';
import { CarouselProductSkeletonComponent } from '@components/skeletons/carousel-product-skeleton/carousel-product-skeleton.component';
import { DEFAULT_PAGE_QUERY } from '@constants/settings.constant';
import { Product, ProductQueryType } from '@models/product.model';
import { ProductService } from '@services/product.service';
import { SLIDE } from '@splidejs/splide';
import { combineLatest, finalize, map, switchMap } from 'rxjs';
import { CarouselProductItemComponent } from '../carousel-product-item/carousel-product-item.component';
import { CarouselWrapperComponent } from '../carousel-wrapper/carousel-wrapper.component';

@Component({
  selector: 'market-carousel-product',
  standalone: true,
  imports: [
    CommonModule,
    CarouselProductItemComponent,
    AddToCartBottomUpComponent,
    RouterModule,
    CarouselProductSkeletonComponent,
    NgClass,
    CarouselWrapperComponent,
  ],
  templateUrl: './carousel-product.component.html',
  styleUrls: ['./carousel-product.component.scss'],
})
export class CarouselProductComponent implements OnInit {
  @Input() title: string = '';
  queryType = input(ProductQueryType.all);
  queryTypes = input<ProductQueryType[]>([]);
  flashSale = input(false);
  @Output() search = new EventEmitter();

  private productService = inject(ProductService);

  loading = signal(true);
  products$ = combineLatest([
    toObservable(this.queryType),
    toObservable(this.queryTypes),
    toObservable(this.flashSale),
  ]).pipe(
    switchMap(([queryType, queryTypes, flashSale]) =>
      this.productService
        .search(
          {
            ...DEFAULT_PAGE_QUERY,
            size: 12,
            keyword: '',
            productType: queryTypes.length ? queryTypes : [queryType],
            categoryId: [],
          },
          flashSale
        )
        .pipe(
          finalize(() => {
            this.loading.set(false);
          })
        )
    ),
    map(x => x.data.items)
  );

  get options() {
    const width = Math.min(480, window.innerWidth);
    return {
      type: SLIDE,
      pagination: false,
      perPage: width / 220,
      arrows: false,
      focus: 0,
    };
  }

  ngOnInit(): void {}

  onAddToCartHandler($event: Product, dialog: AddToCartBottomUpComponent) {
    dialog.showModal($event);
  }

  onSearchHandler() {
    this.search.emit();
  }
}
